<template>
<div style="width:100%">
    <el-empty v-if="!professions || !professions.length" description="未选择包含工程内容！"></el-empty>
    <div v-else>
        <affix anchor-selector=".anyOf_appendBox" v-model="active">            
            <el-tabs class="tab" v-model="activeName">
                <el-tab-pane v-for="(prof,idx) in professions" :name="idx.toString()" :key="prof" :label="prof" ></el-tab-pane>
            </el-tabs>
        </affix>  
    </div>
    
</div> 
</template>

<script>
import { defineComponent } from 'vue'
import affix from './affix.vue'
import {getContainsProfessions} from '@/utils/model'

export default defineComponent({
    components:{affix},
    computed:{
        professions(){
            const project = this.provideCurrentProject
            if(project){
                return getContainsProfessions(project.value)
            }            
        },
        readonly(){
            if(this.genFormProvide){
                return this.genFormProvide.value.readonly
            }
        },
        activeName:{
            get(){
                return this.active.toString()
            },
            set(value){
                this.active = value
            }
            
        }
    },
    data(){
        return {
            active: 0,
            selectedValue:[]
        }
    },
    emits:['update:modelValue'],
    inject:["provideCurrentProject",'genFormProvide'],
    props:{
        modelValue:Array,
        enumOptions: {
            default: () => [],
            type: [Array]
        }
    },
    readonlyRender: true,
    watch: {
        professions:{
            handler(newValue){                
                if(!this.readonly){
                    let changed = false
                    if(newValue && newValue.length){
                        this.selectedValue = []
                        for (let i = 0; i < this.enumOptions.length; i++) {
                            const option = this.enumOptions[i];
                            if(newValue.indexOf(option.label)>=0){
                                this.selectedValue.push(i)
                            }
                        }
                        changed = true
                    }else if(this.selectedValue.length){
                        this.selectedValue = []
                        changed = true
                    }
                    if(changed){
                        this.$emit('update:modelValue', this.selectedValue)
                    }
                    
                }
                

            }
        }
    },
})
</script>
<style scoped>
    .tab{
        background-color: white;
        z-index: 999;
    }
</style>